import { __exports as returnFalse } from '../../../../_virtual/returnFalse.js';
(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = returnFalse;
  function returnFalse() {
    return false;
  }
})(returnFalse);